 <template>
  <button class="btn btn-primary" @click="btnClick">
    <slot>Button</slot>
  </button>
</template>

<script>
export default {
  name: 'PrimaryButton',
  methods: {
    btnClick: function () {
      if (this.click) {
        this.click()
      }
    }
  },
  props: {
    click: Function
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn-primary {
  font-family: sans-serif;
  font-weight: 700;
  background: linear-gradient(to right, #79CC57, #79CF98) !important;
  border-style: none !important;
  border-radius: 2px !important;
}
.btn-primary.wide {
  width: 100%;
}
.btn-primary:hover {
  background-color: #15a589 !important;
  border-color: #18bc9c !important;
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Buttons/Primary.vue